import React, { Fragment, memo, useState } from "react"
import {
  Collapse,
  DropdownToggle,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
} from "reactstrap"
import * as classes from "./styles.module.scss"
import { Link } from "gatsby"
import clsx from "clsx"
import { StaticImage } from "gatsby-plugin-image"
import { Facebook, Instagram, Phone } from "react-feather"

interface Props {}

const DropdownFixedNavbar = memo(({}: Props) => {
  const [collapseOpen, setCollapseOpen] = useState(false)

  const handleCollapseNavbar = () => {
    if (window.innerWidth <= 991) {
      document.documentElement.classList.toggle("nav-open")
      setCollapseOpen(!collapseOpen)
    }
  }

  return (
    <Fragment>
      {collapseOpen ? (
        <div id="bodyClick" onClick={handleCollapseNavbar} />
      ) : null}
      <Navbar className={clsx("fixed-top", classes.bgDark)} expand="lg">
        <Container>
          <div className="navbar-translate">
            <div className={clsx(classes.navbarContentLeft)}>
              <NavbarBrand to="/" tag={Link} id="navbar-brand" className="mr-0">
                <StaticImage
                  className={classes.logo}
                  src="../../../../static/LeightonElectricalWhite.png"
                  alt="Leighton Electrical Logo"
                />
              </NavbarBrand>
              <NavbarBrand to="/" tag={Link} id="navbar-brand" className="mr-0">
                <StaticImage
                  className={classes.logo2}
                  src="../../../../static/mastercraftwhite.png"
                  alt="Leighton Electrical Logo"
                />
              </NavbarBrand>
            </div>
            
            <UncontrolledDropdown
                  aria-expanded={collapseOpen}
                  id="navbarDropdownMenuLink"
                  className="navbar-toggler"
                  nav
                  tag={Link}
                  to="tel:094040044"
                
                >
                  <Phone />
                </UncontrolledDropdown>
            <button
              onClick={handleCollapseNavbar}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar>
            <Nav className="ml-auto" id="ceva" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/"
                  onClick={handleCollapseNavbar}
                >
                  <p>Home</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              {/* <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/about-us"
                  onClick={handleCollapseNavbar}
                >
                  <p>About Us</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/#contact-us"
                  onClick={handleCollapseNavbar}
                >
                  <p>Contact Us</p>
                </DropdownToggle>
              </UncontrolledDropdown> */}
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/main-services"
                  onClick={handleCollapseNavbar}
                >
                  <p>Services</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="/enquiry"
                  onClick={handleCollapseNavbar}
                >
                  <p>Enquiry</p>
                </DropdownToggle>
              </UncontrolledDropdown>
            </Nav>
            <Nav className="ml-auto" id="ceva" navbar>
            <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="tel:094040044"
                  onClick={handleCollapseNavbar}
                >
                  <p>09 404 0044</p>
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav 
                  tag={Link}
                  to="https://www.facebook.com/leightonelectrical"
                  onClick={handleCollapseNavbar}
                >
                  <Facebook />
                </DropdownToggle>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  color="default"
                  id="navbarDropdownMenuLink"
                  nav
                  tag={Link}
                  to="https://www.instagram.com/leighton_electrical/?hl=en"
                  onClick={handleCollapseNavbar}
                >
                  <Instagram />
                </DropdownToggle>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </Fragment>
  )
})

export default DropdownFixedNavbar
